
<script>
import Avatar from '@/views/dark-template/sidebar/Avatar'
import SidebarSection from '@/views/dark-template/sidebar/Section'
export default {
  name      : 'Sidebar',
  components: { SidebarSection, Avatar },
  data () {
    return {
      sections: {
        info: {
          title: 'INFO',
          items: [
            {
              name: 'Email',
              icon: 'mdi-email',
              text: 'nicholasfal19@gmail.com',
            },
            {
              name: 'Website',
              icon: 'mdi-web',
              text: 'nicholasfalcone.tech',
            },
            {
              name: 'Birth Date',
              icon: 'mdi-cake-variant',
              text: 'Apr 24, 1997',
            },
            {
              name: 'Located',
              icon: 'mdi-map-marker',
              text: 'Turin, Italy',
            },
          ],
        },
        socials: {
          title: 'SOCIALS',
          items: [
            {
              icon: 'mdi-github-circle',
              text: 'github.com/NicholasFalcone',
              link: 'https://github.com/NicholasFalcone',
            },
            {
              icon: 'mdi-linkedin-box',
              text: 'linkedin.com/in/nicholas-falcone-a35521146',
              link: 'https://www.linkedin.com/in/nicholas-falcone-a35521146/',
            },
            {
              icon: 'mdi-twitter',
              text: 'twitter.com/nicho_falcone',
              link: 'https://twitter.com/nicho_falcone',
            },
          ],
        },
        hobbies: {
          title: 'HOBBIES',
          items: [
            {
              icon: 'mdi-auto-fix',
              text: 'Hacking Stuffs',
            },
            {
              icon: 'guidance:climbing-wall',
              text: 'Climbing',
            },
            {
              icon: 'mdi-movie-roll',
              text: 'Ciname',
            },
            {
              icon: 'mdi-gamepad-variant',
              text: 'Videogames',
            },
            {
              icon: 'mdi-music',
              text: 'Music',
            },
            {
              icon: 'mdi-book-open-page-variant',
              text: 'Books',
            },
          ],
        },
        languages: {
          title: 'LANGUAGES',
          items: [
            {
              text : 'English',
              level: 'B2',
            },
            {
              text : 'Italian',
              level: 'C2',
            },
          ],
        },
      },
    }
  },
}
</script>

<style scoped>
  .sidebar{
      background: #2e2e2e;
  }
</style>

<template>
  <v-card
    color="grey darken-3"
    dark
  >
    <v-card-text>
      <avatar />
      <div class="text-sm-center mb-4 mt-3">
        <h1>
          Nicholas <span class="light-blue--text text--lighten-3">Falcone</span>
        </h1>
      </div>
      <sidebar-section :options="sections.info" />
      <sidebar-section :options="sections.socials" />
      <sidebar-section :options="sections.hobbies">
        <template v-slot:item="{item}">
          <v-chip>
            <v-avatar>
              <iconify-icon :icon="item.icon" />
            </v-avatar>
            {{ item.text }}
          </v-chip>
        </template>
      </sidebar-section>
      <sidebar-section :options="sections.languages">
        <template v-slot:items="{items}">
          <v-container pa-0>
            <v-layout
              wrap
              class="text-xs-center"
            >
              <template
                v-for="(item, i) in items"
              >
                <v-flex
                  :key="i"
                  md3
                  sm4
                  xs4
                >
                  <v-progress-circular
                    rotate="360"
                    size="65"
                    width="2"
                    :value="100"
                    color="white"
                    class="ma-2"
                  >
                    <div style="display:flex; flex-direction:column">
                      <span style="disply:block">{{ item.text }}</span>
                      <span style="disply:block"><b>{{ item.level }}</b></span>
                    </div>
                  </v-progress-circular>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </template>
      </sidebar-section>
    </v-card-text>
  </v-card>
</template>
